import "../loader/loader.css";

export const Loader = () => {

    return (
        <div className="loader">
          <img src="https://ik.imagekit.io/qsdtqu5hp/loader.svg?updatedAt=1685742418182" alt="loader" />
        </div>
      );
}